// extracted by mini-css-extract-plugin
module.exports = {"item":"CharItem_item__pfj69","label":"CharItem_label__3g_oj","value":"CharItem_value__33HBN","accent":"CharItem_accent__o5p4_"};